import React from 'react';
import cx from 'classnames';

import { Body1, Heading3, Heading4, Tag } from '../Typography';

import styles from './index.module.scss';

export interface TextBlockProps {
  eyebrow?: string;
  title?: string;
  price?: string;
  text?: string;
  className?: string;
  priceClassName?: string;
}

const TextBlock: React.FC<TextBlockProps> = ({
  eyebrow,
  title,
  price,
  text,
  className,
  priceClassName,
}) => {
  const isOnlyEyebrow = eyebrow && !title && !price && !text;
  return (
    <div className={cx(styles.wrapper, className)}>
      {eyebrow && (
        <Tag
          className={cx(styles.eyebrow, {
            [styles.noMargin]: isOnlyEyebrow,
          })}
        >
          {eyebrow}
        </Tag>
      )}

      <Heading3 className={styles.title}>{title}</Heading3>

      {price && (
        <Heading4 className={cx(styles.price, priceClassName)}>
          {price}
        </Heading4>
      )}

      {text && <Body1 className={styles.text}>{text}</Body1>}
    </div>
  );
};

export default TextBlock;
